import _ from 'underscore';

import { addMessageToFieldConfig } from '../message-mapper';

export class ExistingFields {
  constructor({
    i18n,
    isPageFeedEnabled,
    isGoogleImageExtensionImportOptionEnabled,
    isGoogleLogoExtensionImportOptionEnabled,
    isGoogleUpdateAdUrlsImportOptionEnabled,
    isGoogleUpdateSitelinkUrlsImportOptionEnabled,
    isGoogleAdCustomizerAttributesImportOptionEnabled,
    isGoogleConversionGoalsImportOptionEnabled,
    isBrandSuitabilityImportOptionEnabled,
  }) {
    this.i18n = i18n;

    this.optionalItemFields = _.compact([
      {
        property: 'ImportUpdateEntityPreference_UpdateExistingNegativeKeywordList',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateNegativeSites',
        showLabel: false,
      },
      isGoogleUpdateAdUrlsImportOptionEnabled && {
        property: 'ImportUpdateEntityPreference_UpdateAdUrls',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateKeywordDestinationUrl',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateTrackingTemplateAndCustomParams',
        message: i18n.getString('Import_ImportOptions_TrackingTemplateCustomParams_FinalURLSuffix'),
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateLanguageForExistingAdGroups',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateAdGroupNetworkSetting',
        showLabel: false,
      },
      {
        property: 'UpdateLabelsAndAssociations',
        message: this.i18n.getString('Import_ImportOptions_UpdateLabelsAndAssociations'),
        showLabel: false,
      },
      {
        property: 'UpdateCustomFiltersForShoppingCampaigns',
        message: this.i18n.getString('Import_ImportOptions_UpdateCustomFiltersForShoppingCampaigns'),
        showLabel: false,
      },
      isBrandSuitabilityImportOptionEnabled && {
        property: 'ImportUpdateEntityPreference_UpdateBrandSuitability',
        message: this.i18n.getString('Import_ImportOptions_BrandSuitabilityImportOption'),
        showLabel: false,
      },
    ]);

    this.existingTargetingFields = _.compact([
      {
        property: 'ImportUpdateEntityPreference_UpdateLocationTargets',
        label: this.i18n.getString('Import_ImportOptions_LocationTarget'),
        showLabel: false,
        message: this.i18n.getString('ImportUpdateEntityPreference_UpdateLocationTargets'),
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateDayTimeTargets',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateDeviceTargets',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateDemographicTargets',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateAudienceTargets',
        showLabel: false,
        message: this.i18n.getString('Import_ImportOptions_AudienceListsAndTargets'),
      },
    ]);

    this.existingAdExtensionFields = _.compact([
      {
        property: 'ImportUpdateEntityPreference_UpdateAppAdExtensions',
        label: this.i18n.getString('Import_ImportOptions_AdExtensions'),
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateCallAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateCalloutAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateLocationAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdatePriceAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdatePromotionAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateReviewAdExtensions',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateSitelinkAdExtensions',
        showLabel: false,
      },
      isGoogleUpdateSitelinkUrlsImportOptionEnabled && {
        property: 'ImportUpdateEntityPreference_UpdateSitelinkUrls',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateStructuredSnippetAdExtensions',
        showLabel: false,
      },
      isGoogleImageExtensionImportOptionEnabled && {
        property: 'ImportUpdateEntityPreference_UpdateImageAdExtensions',
        showLabel: false,
      },
      isGoogleLogoExtensionImportOptionEnabled && {
        property: 'ImportUpdateEntityPreference_UpdateLogoAdExtensions',
        showLabel: false,
      },
    ]);

    this.existingFeedFields = _.compact([
      isPageFeedEnabled && {
        property: 'ImportUpdateEntityPreference_UpdatePageFeeds',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateAdCustomizerFeeds',
        showLabel: false,
      },
      isGoogleAdCustomizerAttributesImportOptionEnabled && {
        property: 'ImportUpdateEntityPreference_UpdateAdCustomizerAttributes',
        showLabel: false,
      },
    ]);

    this.statusFields = [
      {
        property: 'ImportUpdateEntityPreference_UpdateStatusForExistingCampaigns',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateStatusForExistingAdGroups',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateStatusForExistingAds',
        showLabel: false,
      },
      {
        property: 'ImportUpdateEntityPreference_UpdateStatusForExistingKeywords',
        showLabel: false,
      },
    ];

    this.existingConversionFields = isGoogleConversionGoalsImportOptionEnabled
      ? [{
        property: 'ImportUpdateEntityPreference_UpdateConversionGoals',
        showLabel: false,
      }]
      : [];

    addMessageToFieldConfig(
      this.i18n,
      this.optionalItemFields,
      this.existingTargetingFields,
      this.existingAdExtensionFields,
      this.existingFeedFields,
      this.statusFields,
      this.existingConversionFields
    );
  }

  getOptionalItemFields() {
    return this.optionalItemFields;
  }

  getExistingTargetingFields() {
    return this.existingTargetingFields;
  }

  getExistingAdExtensionFields() {
    return this.existingAdExtensionFields;
  }

  getExistingFeedFields() {
    return this.existingFeedFields;
  }

  getStatusFields() {
    return this.statusFields;
  }

  getExistingConversionFields() {
    return this.existingConversionFields;
  }
}

